import DashboardSettings from "./DashboardSettings";

export default DashboardSettings;
